export const DEFAULT_TOKENS_ADDRESS_LIST = [
	'dac9b9520fbb96d2c50dca5cd99113d19f096cde575407c1b8a457e544338064',
	'f1a01623760ea390dba8dd83249514a0a036fa669886dfa62c3a4048d0ab36f5',
	'0a4d63cfa294feac9081d922c5779212f0a2c995972f3f6b46ade3116a18d3f6',
	'd5080e422a00a952f61b3b5c941856daf758a4f90eb487dbb00bd4741d67f5de',
	'a7a40584e22dda1633204e52c034c0dbd013a3687aea3abfe256a796490a41f9',
];
